export default __webpack_public_path__ + "static/media/situation-mention-associate.efa6d2f2.gif";